// Mapping between the assembly type values and the respective icon names

export default {
  aussenwand: 'outside-wall',
  decke: 'ceiling',
  steildach: 'steep-roof',
  trennwand: 'dividing-wall-single',
  twzweischalig: 'dividing-wall-double',
};
